<template>
  <div class="box">
    <div class="header-title">AI智慧管理</div>
    <div class="content">
      <div class="content-left">
        <div>
          通过数据基础-AI赋能-运营升级的逻辑链条，实现医院运营管理的精益化转型。
        </div>
        <div class="more-btn eno-common-button" @click="toPage('/AISmartManagement')">了解更多</div>
      </div>
      <img src="../../../assets//images//home/ai_right.png" alt="" />
    </div>
  </div>
</template>

<script>
import { config } from "../../../constant/config.js";
import { toPage } from '@/utils/index.js'

export default {
  data() {
    return {};
  },
  mounted() { },
  methods: {
    toPage
  },
};
</script>

<style lang="less" scoped>
@height: 40px;

.box {
  padding: @commonPadding;
  background-color: @mainTextColor;
  color: @black;

  .header-title {
    font-size: @height;
    padding-bottom: @height;
  }

  .content {
    width: 100%;
    display: flex;
    height: auto;

    .content-left {
      width: 50%;
      background-color: #2e2e38;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      padding: 0 @commonPadding;
      color: @mainTextColor;
      flex-direction: column;

      .more-btn {
        border: 1px @lightBgColor solid;
        align-self: flex-start;
        margin-top: 20px;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

@media @mobile {
  .box {
    padding: @commonPadding_h5;

    .header-title {
      font-size: @fontSize24;
      padding-bottom: @height;
    }

    .content {
      width: 100%;
      display: flex;
      flex-direction: column-reverse;

      .content-left {
        width: 100%;
        font-size: @fontSize16;
        padding: 20px;

        .more-btn {
          border: 1px @lightBgColor solid;
          align-self: flex-start;
          margin-top: 20px;
        }
      }

    }
  }
}
</style>
